import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_menu-clients",
  "use": "svg_menu-clients-usage",
  "viewBox": "0 0 20 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 19\" id=\"svg_menu-clients\"><path d=\"M18 4h-3V2c0-1.11-.89-2-2-2H7C5.89 0 5 .89 5 2v2H2C.89 4 0 4.89 0 6v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM7 2h6v2H7V2zm11 15H2v-2h16v2zm0-5H2V6h3v2h2V6h6v2h2V6h3v6z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol